export default __webpack_public_path__ + "static/media/dashboards_teaser.cebb26f5.png";